import { Button } from "@/components/ui/button";
import { m } from "framer-motion";

export default function HeroSection() {
  return (
    <section
      className="relative overflow-hidden h-[90svh] md:min-h-[100dvh] lg:min-h-0 lg:h-auto"
      dir="rtl">
      
      {/* Background — desktop */}
      <img
        src="/images/hero-bg.webp"
        alt=""
        aria-hidden="true"
        width={1920}
        height={955}
        fetchPriority="high"
        decoding="sync"
        className="hidden lg:block w-full h-auto" />
      {/* Background — tablet */}
      <img
        src="/images/hero-bg-tablet.png"
        alt=""
        aria-hidden="true"
        width={1080}
        height={1420}
        fetchPriority="high"
        decoding="sync"
        className="hidden md:block lg:hidden w-full min-h-[100dvh] object-cover" />
      {/* Background — mobile */}
      <img
        src="/images/hero-bg-mobile.png"
        alt=""
        aria-hidden="true"
        width={880}
        height={1920}
        fetchPriority="high"
        decoding="sync"
        className="md:hidden w-full h-full object-cover object-bottom absolute inset-0" />
      


      {/* Layer 4 — Text content block, centered */}
      <div className="absolute inset-0 container z-10 flex flex-col items-start justify-center md:pr-4">
        <m.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="w-full max-w-4xl text-right h-full flex flex-col justify-start pt-16 md:justify-center md:pt-0 md:pb-0 md:space-y-2 mr-[5%] ml-auto">
          
          <div className="space-y-4 md:space-y-6">

             <h1 className="text-3xl font-extrabold leading-relaxed text-foreground md:text-6xl lg:text-7xl md:leading-[1.3] md:mr-[16%]">
               <span className="block text-[hsl(201,72%,60%)] font-bold text-2xl md:text-5xl lg:text-6xl mb-3 md:mb-8 [text-shadow:_0_0_25px_rgba(144,206,241,0.6),_0_0_40px_rgba(144,206,241,0.2)]">
                זרימת עבודה חכמה ב-BIM:
              </span>
              פתרונות Revit
              <br />
              לדיוק ותפוקה מקסימלית
            </h1>

            <p className="max-w-[185px] md:max-w-2xl text-base text-muted-foreground md:text-2xl leading-[2.2] md:leading-[2.4] mr-0 md:mr-[16%] ml-auto">
              Bimbee מנגישה כלים ייעודיים לניהול משפחות,{" "}
              <br className="hidden md:block" />
              הפקת רשימות אדריכליות ודיטיילינג ברזל מהיר.{" "}
              <br className="hidden md:block" />
              פתרונות שנולדו מתוך ניסיון עשיר בתכנון וניהול{" "}
              <br className="hidden md:block" />
              BIM, כדי לאפשר לכם להתמקד ביצירה נטו.
            </p>
          </div>

          <div className="flex flex-row items-center justify-start gap-3 mt-4 md:mt-0 md:pt-2 md:mr-[16%] md:gap-4">
            <Button asChild size="lg" className="h-11 px-6 text-base md:h-14 md:px-10 md:text-xl bg-primary-ice text-foreground hover:bg-primary-ice/80 border-0 font-bold">
              <a href="#apps">צפייה באפליקציות</a>
            </Button>
          </div>
        </m.div>
      </div>
    </section>);

}